import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../components/Button'
import '../assets/languages/i18n'
import { Box, Checkbox, Divider, Grid, Link, Paper, Toolbar, Typography } from "@mui/material";
import LoginBG from "../../src/assets/images/bg.svg"
// import {ReactComponent as AlertIcon} from "../../src/assets/icons/Alert.js"
import { makeStyles } from "@mui/styles";
import LoginLogo1 from "../../src/assets/images/login/design-stats-pana-1.png"
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import pencilWhite from "../icons/pencil-white.svg";
import { ReactSVG } from "react-svg";
import cssVariables from "../theme/cssVariables";
import AlertIcon from "../assets/icons/Alert";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
// import CloseIcon from '@mui/icons-material/Close';
import { useCookies } from 'react-cookie';
import consentService from "../services/consent.service";
import CloseIcon from "../assets/images/plus-circle-fill.svg";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/auth";
import * as Util from "../services/global.service";


const useStyles = makeStyles({
    customScroll: {
        paddingTop: "31px !important",
        '& > div': {
            maxWidth: "none",
            paddingRight: "20px",
            minHeight: "500px",
            '&::-webkit-scrollbar': {
                borderRadius: "10px",
            },
            '&::-webkit-scrollbar-track': {
                borderRadius: "10px",
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: "10px",
            }
        }
    },
    customBoxText: {
        padding: "36px 19px 52px 48px !important",
    },
    customChildBoxText: {
        marginRight: "20px"
    },
    btnDisabled: {
        '& > a': {
            color: "#FFFFFF !important",
            backgroundColor: "#BABABA !important",
        }
    },
    btn: {
        width: "100%",
        textAlign: "center",
        padding: "0 20px",
        '& > button': {
            width: "100%",
            maxWidth: "376px",
            margin: "0 auto",
        }
    },
    accept: {
        padding: "40px 0 30px 24px",
        '& p > span ': {
            marginLeft: "-12px",
            marginTop: "-5px",
        },
        '& span > svg ': {
            width: "30px",
            height: "30px",
        }
    }
});

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
function SimpleDialog(props) {
    const { t } = useTranslation()
    const { notAccept, onClose, open } = props;
    const handleClose = () => {
        onClose();
    };
    const onConfirmPress = () => {
        notAccept()
    }
    const onCancelPress = () => {
        onClose();
    }
    const onClosePress = () => {
        onClose();
    }
    return (
        <Dialog onBackdropClick={() => { return false }} onClose={handleClose}
            fullWidth
            open={open} maxWidth='sm'
        >
            <Grid container direction='column' m={0} p={3}>
                {/*<DialogTitle>Set backup account</DialogTitle>*/}
                <Grid item container p={1}>
                    <Grid item container>
                        <Typography color="#404349" variant="h3">{t('consent.label.confirmNavBack')}</Typography>
                        <Box flex={1} />
                        {/*<IconButton onClick={onClosePress}>*/}
                        {/*    <CloseIcon/>*/}
                        {/*</IconButton>*/}
                    </Grid>
                </Grid>
                <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
                {/*<Button startIcon={<CloseIcon />}/>*/}
                <Divider />
                <Grid container direction='column' item>
                    <Grid item justifyContent="center" container direction='column' sx={{ 'text-align': "center" }} p={4}>
                        <Grid item sx={12} lg={6}>
                            <AlertIcon fill='#EFB76D' width="77px" />
                            {/*<img*/}
                            {/*    color="warning"*/}
                            {/*    src={AlertIcon}*/}
                            {/*    className="icon-24"*/}
                            {/*    alt="pencil"*/}
                            {/*/>*/}
                            {/*<ReactSVG src={AlertIcon} color="warning"/>*/}
                            {/*<ErrorOutlineIcon color="warning" sx={{"font-size": "5em"}}/>*/}
                        </Grid>
                        <Grid item sx={12} lg={6}>
                            <Typography color="#404349" pt={4} dangerouslySetInnerHTML={{ __html: t('consent.msg.confirmNavBack') }}></Typography>
                        </Grid>
                    </Grid>
                    <Grid item container alignItems="center" sx={{ 'text-align': "center" }}>
                        <Grid item sx={12} lg={6}>
                            <Button onClick={onCancelPress} variant="dashed-solid" sx={{ width: "70%", height: "45px" }}>
                                <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#404349">
                                    {t('label.cancel')}
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item sx={12} lg={6}>
                            <Button onClick={onConfirmPress} sx={{ width: "70%", height: "45px" }} color="warning">
                                <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                    {t('label.confirm')}
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}

const LoginView = () => {
    const user = useSelector((state) => state?.auth);
    const [consent, setConsent] = useState({
        Description: "",
        is_use: "",
        serial: "",
        status: "",
        title: "",
        updated_at: "",
        version: "",
    });
    const classes = useStyles();
    const navigate = useNavigate();
    const { t } = useTranslation()
    const [isConsentChecked, setConsentChecked] = React.useState(false);
    const [isScrollEnd, setScrollEnd] = React.useState(false);
    const [isNavbackDialogOpen, setNavbackDialogOpen] = React.useState(false);
    const dispatch = useDispatch();
    const parseConditionTxt = () => {
        return isScrollEnd ? '#404349' : 'rgba(153,153,153,0.6)';
    }
    const onConsentChange = (props) => {
        setConsentChecked(props.target.checked)
    }
    const handleClose = (value) => {
        setNavbackDialogOpen(false);
    };
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            let ele = evt?.currentTarget === undefined || evt?.currentTarget === null ? evt : evt.currentTarget;
            let posOfTopScrollAtBottom = ele.scrollHeight - ele.offsetHeight;
            if (!posOfTopScrollAtBottom) {
                setScrollEnd(true)
            } else {
                let delta = Math.abs(ele.scrollTop - posOfTopScrollAtBottom);
                if (delta <= 5) { // avoid very small scroll calculate
                    setScrollEnd(true)
                } else {
                    //if scroll to bottom
                    // position tolerance 10%
                    if ((delta / posOfTopScrollAtBottom) <= 0.1) {
                        setScrollEnd(true)
                    }
                }
            }
        }
    }
    const onNavbackPress = (evt) => {
        setNavbackDialogOpen(true);
    }
    const getConsentData = () => {
        consentService.consent().then(
            async (response) => {
                await setConsent(response?.data?.data?.consent)
                onScroll(document.getElementById("consentText"))
            },
        );
    }

    const acceptConsent = () => {
        consentService.acceptConsent(consent.serial, 'accept').then(
            (response) => {
                let data = user?.user
                data.consent = true
                localStorage.setItem("user", JSON.stringify(data));
                navigate('/kpi/home', { replace: false });
            },
        );
    }

    const notAcceptConsent = () => {
        consentService.acceptConsent(consent.serial, 'notaccept').then(
            (response) => {
                /*
                dispatch(logout())
                localStorage.removeItem("user");
                localStorage.removeItem("proxy");
                navigate('/'+localStorage.getItem("site"), { replace: false });
                */


                dispatch(logout()).then(
                    (response) => {
                        localStorage.removeItem("user");
                        localStorage.removeItem("date");
                        localStorage.removeItem("proxy");
                        let pathTologin = response?.data?.data?.url
                        if (Util.formatData(pathTologin, false) !== false) {
                            const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
                            if (newWindow) newWindow.opener = null
                        } else {
                            console.log('Navigate', 13);
                            navigate('/', { replace: false });
                            //window.location.href = '/' + localStorage.getItem("site")
                        }
                    }
                ).catch((err) => {
                    localStorage.removeItem('date');
                    localStorage.removeItem('user');
                    localStorage.removeItem("proxy");

                    console.log('Navigate', 14);
                    //navigate('/' + localStorage.getItem("site"), { replace: false });
                    window.location.href = '/' + localStorage.getItem("site")
                })
            },
        );
    }

    useEffect(() => {
        getConsentData()
        document.getElementById('signin').style.display = "none"
    }, [])
    const styles = {
        paperContainer1: {
            'backgroundImage': `url(${LoginBG})`,
            'background-size': 'cover'
        },
        paperContainer2: {
            'backgroundImage': `url(${LoginLogo1})`,
            'background-size': 'cover'
        },
        boxContent: {
            width: "100%",
            maxWidth: "1400px",
        },
        condition: {
            fontSize: "14px",
            lineHeight: "15.4px",
            color: "#CC6058"
        },
        btnLogin: {
            color: cssVariables.color.primary,
            fontSize: "18px",
            lineHeight: "19.8px",
            fontWeight: "500",
            textDecoration: "none"
        },
        boxLogin: {
            paddingTop: "11px",
            paddingBottom: "19px",
        }
    };

    return (
        <>
            <Helmet>
                <title>Login | PMS</title>
            </Helmet>
            <Grid container sx={{
                height: 'auto',
                minHeight: '100%',
                'backgroundImage': `url(${LoginBG})`,
                'background-size': 'cover'
            }}>
                <Grid container item
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        alignItems: 'center',
                        overflow: 'hidden',
                        boxShadow: 0,
                        fontWeight: 'bold',
                    }}>
                    <Grid item justifyContent="center" container>
                        <Paper style={styles.boxContent} elevation={3} height={1} sx={{
                            bgcolor: 'background.paper',
                            boxShadow: 1,
                            borderRadius: 4,
                            m: { xs: 1, md: 10 },
                            p: { xs: 1, md: 10 },
                            // overflow: 'auto',

                        }}
                            classes={{ root: classes.customBoxText }}
                        >
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} direction={"column"}>
                                <Grid item xs={6}>
                                    <Typography variant="h1" fontSize={36} color="#404349" align="center">
                                        {t('consent.label.header')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} classes={{ root: classes.customScroll }}>
                                    <Box id="consentText" sx={{ maxHeight: 500, overflow: 'auto' }} onScroll={onScroll} maxWidth="md">
                                        <Typography color="#404349" dangerouslySetInnerHTML={{ __html: consent?.Description ?? "" }}>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} class={`${classes.accept}`} sx={{ display: "flex" }}>
                                    <Box sx={{ 'color': parseConditionTxt, display: "flex" }}>
                                        <Checkbox onClick={onConsentChange} disabled={!isScrollEnd} sx={{ width: "27px", height: "27px" }} />
                                        <Box pl="20px">
                                            <Typography sx={{ 'color': parseConditionTxt }}>{t('consent.label.acceptConsent')}</Typography>
                                            <Typography sx={{ 'color': parseConditionTxt }}>{t('consent.label.acceptConsent2')}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} container justifyContent="center">
                                    <Grid item class={!isConsentChecked ? `${classes.btnDisabled} ${classes.btn}` : `${classes.btn}`}>
                                        <Button disabled={!isConsentChecked} onClick={acceptConsent}>
                                            <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="39px" fontWeight="600" color="#FFF">
                                                {t('label.confirm')}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography align="center" style={styles.boxLogin}>
                                        <Link onClick={onNavbackPress} href="#" style={styles.btnLogin}>
                                            {t('consent.label.backToLogin')}
                                        </Link>
                                    </Typography>
                                    <Typography style={styles.condition} align="center" dangerouslySetInnerHTML={{ __html: t('consent.msg.condition1') }}></Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                {/* consent popover*/}
                {/*footer*/}
                {/* <Grid container item sx={{
                    bottom: 0
                }}
                >
                    <Toolbar color="primary" sx={{ 'align-items': 'end' }}>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4}>
                            Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
                        </Typography> */}
                {/*<Typography variant="h6" component="div" sx={{flexGrow: 0}}>*/}
                {/*    Privacy Policy*/}
                {/*</Typography>*/}
                {/*<Typography variant="h6" component="div" sx={{flexGrow: 0}}>*/}
                {/*    Terms of Service*/}
                {/*</Typography>*/}
                {/* </Toolbar>
                </Grid> */}
            </Grid>
            <SimpleDialog
                notAccept={notAcceptConsent}
                open={isNavbackDialogOpen}
                onClose={handleClose} />
        </>
    );
};
export default LoginView;

